import { DeleteBlog, UpdateBlog } from "../../redux/blog";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { BlogForm } from "./BlogForm";
import { ErrorBanner } from "../../components/banner";
import { IoTrash } from "react-icons/io5";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";

export const BlogEdit = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { error, loading } = useSelector((state) => state.blogs);
  let navigate = useNavigate();

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save your edits?`)) {
      dispatch(UpdateBlog(state.blog.id, values));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/press");
      }, 500);
    }
  };

  const onDeleteSubmit = () => {
    if (window.confirm(`Are you sure you want to delete this?`)) {
      dispatch(DeleteBlog(state.blog));
    }

    if (!loading && !error) {
      setTimeout(() => {
        navigate("/press");
      }, 500);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Section>
      <SubNav>
        <li onClick={onDeleteSubmit}>
          <IoTrash />
          <Text>Delete</Text>
        </li>
      </SubNav>
      {error && <ErrorBanner text={error} />}
      <BlogForm initialValues={state.blog} onFormSubmit={onFormSubmit} />
    </Section>
  );
};

const SubNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;

  li {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    color: red;

    p {
      margin: 0;
      padding: 0 0 0 0.5rem;
      color: red;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;
